// "use client";

interface PillProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export default function Pill({ children, onClick, className }: PillProps) {
  return (
    <div
      onClick={onClick}
      className={`flex items-center p-2 px-4 text-sm border rounded-md cursor-pointer border-border/20 bg-gradient-to-r from-card via-indigo-500/20 to-card ${className}`}
    >
      <span className="flex items-center gap-2">{children}</span>
    </div>
  );
}
